var bearer = {

    request: function (req, token) {
        this.options.http._setHeaders.call(this, req, {
            Authorization: 'Bearer ' + token
        })
    },

    response: function (res) {
        var headers = this.options.http._getHeaders.call(this, res)
        var token = headers.Authorization || headers.authorization
        if (!token && typeof res.data.token !== 'undefined') {
            token = res.data.token
            return token
        }
        if (!token && typeof res.data.access_token !== 'undefined') {
            token = res.data.access_token
            return token
        }

        if (token) {
            token = token.split(/Bearer:?\s?/i)
            return token[token.length > 1 ? 1 : 0].trim()
        }
    }
}
export default bearer
